module.exports = __webpack_public_path__ + "img/upays-keys.a4fca33e.png";